export default "__VITE_ASSET__PSoeIMmb__"